import React from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Tenant } from '../../types';
interface AppLayoutProps {
  currentView: 'admin' | 'club';
  currentPage: string;
  onNavigate: (page: string) => void;
  onToggleView: () => void;
  tenant?: Tenant;
  children: React.ReactNode;
}
export function AppLayout({
  currentView,
  currentPage,
  onNavigate,
  onToggleView,
  tenant,
  children
}: AppLayoutProps) {
  return <div className="flex h-screen w-full bg-slate-50 overflow-hidden font-sans" data-id="element-19">
      <Sidebar currentView={currentView} currentPage={currentPage} onNavigate={onNavigate} onToggleView={onToggleView} tenant={tenant} data-id="element-20" />
      <div className="flex-1 flex flex-col min-w-0" data-id="element-21">
        <Header currentView={currentView} currentPage={currentPage} tenant={tenant} data-id="element-22" />
        <main className="flex-1 overflow-y-auto p-6 lg:p-8" data-id="element-23">
          <div className="max-w-7xl mx-auto" data-id="element-24">{children}</div>
        </main>
      </div>
    </div>;
}